import { IHotelDescriptionRepository } from '../types';

export const NAMESPACE = 'hotelDescriptionRepositoryName';

export default {
    namespaced: true,
    state: {
        hotelDescriptionList: [],
    },
    mutations: {
        setHotelDescriptionList: (state, newList) => {
            state.hotelDescriptionList = newList;
        },
    },
    getters: {
        isNewHotelDescription: (state) => state.hotelDescriptionList.filter((description) => description.name === 'newHotelDescription')[0].value,
        hotelDescriptionMainText: (state) => state.hotelDescriptionList.filter((description) => description.type === 'descriptionMainText')[0]?.value,
        hotelDescriptionUpdateDate: (state) => state.hotelDescriptionList.filter((description) => description.type === 'updateDate'),
        hotelDescriptionTerritory: (state) => state.hotelDescriptionList.filter((description) => description.type === 'territory'),
        hotelDescriptionLocationAddress: (state) => state.hotelDescriptionList.filter((description) => description.type === 'locationAddress'),
        hotelDescriptionImportant: (state) => state.hotelDescriptionList.filter((description) => description.type === 'important')[0],
        hotelDescriptionFacilities: (state) => state.hotelDescriptionList.filter((description) => description.type === 'facility'),
        hotelDescriptionAirportName: (state) => state.hotelDescriptionList.filter((description) => description.type === 'airport')[0]?.value,
        hotelDescriptionAirportLocation: (state) => state.hotelDescriptionList.filter((description) => description.type === 'locationAirport')[0],
        hotelDescriptionLocationDistance: (state) => state.hotelDescriptionList.filter((description) => description.type === 'locationDistance'),
    },
} as IHotelDescriptionRepository;